var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoTodo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.32,
    height: 52.999,
    viewBox: "0 0 28.727 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21169",
    "data-name": "Grupo 21169",
    transform: "translate(-1510.295 -980.367)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21168",
    "data-name": "Grupo 21168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21167",
    "data-name": "Grupo 21167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15940",
    "data-name": "Trazado 15940",
    d: "M1539.017,989.817a1.264,1.264,0,0,0-.024-.245c-.012-.048-.027-.1-.044-.143-.01-.029-.016-.059-.028-.087a1.059,1.059,0,0,0-.081-.152c-.011-.02-.02-.041-.032-.06a1.217,1.217,0,0,0-.155-.189l-8.2-8.211a1.16,1.16,0,0,0-.188-.154.308.308,0,0,1-.051-.028,1.219,1.219,0,0,0-.161-.081c-.026-.011-.054-.016-.079-.025a1.155,1.155,0,0,0-.152-.046,1.187,1.187,0,0,0-.245-.029h-18.046a1.235,1.235,0,0,0-1.236,1.234h0v32.53a1.236,1.236,0,0,0,1.234,1.236h26.257a1.238,1.238,0,0,0,1.236-1.236Zm-8.2-5.228,3.987,3.992h-3.992Zm-18.05,28.306V982.84h15.577v6.978a1.236,1.236,0,0,0,1.234,1.236h6.966V1012.9Z",
    fill: "#C73A8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15941",
    "data-name": "Trazado 15941",
    d: "M1517.7,987.273h3.9a1.236,1.236,0,0,0,0-2.472h-3.9a1.236,1.236,0,0,0,0,2.472Z",
    fill: "#C73A8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15942",
    "data-name": "Trazado 15942",
    d: "M1517.7,991.415h3.9a1.236,1.236,0,1,0,0-2.473h-3.9a1.236,1.236,0,0,0,0,2.473Z",
    fill: "#C73A8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15943",
    "data-name": "Trazado 15943",
    d: "M1517.7,995.864h3.9a1.236,1.236,0,0,0,0-2.472h-3.9a1.236,1.236,0,0,0,0,2.472Z",
    fill: "#C73A8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15944",
    "data-name": "Trazado 15944",
    d: "M1524.366,998.883a1.235,1.235,0,0,0-1.234-1.164h-6.539a1.237,1.237,0,0,0-1.234,1.163l-.622,10.522a1.235,1.235,0,0,0,1.159,1.307h7.851a1.235,1.235,0,0,0,1.237-1.233,1.167,1.167,0,0,0-.014-.187Zm-7.085,9.357.477-8.05h4.207l.467,8.05Z",
    fill: "#C73A8D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15945",
    "data-name": "Trazado 15945",
    d: "M1519.865,1004.216a1.226,1.226,0,1,0,1.226,1.226,1.226,1.226,0,0,0-1.226-1.226Z",
    fill: "#C73A8D"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoTodo);
export default __webpack_public_path__ + "static/media/Icono_Todo.1e587873a27b1d14daa4f151fb376f4a.svg";
export { ForwardRef as ReactComponent };